import { FetchStatus } from '@powdr/constants';

import { ROADS_PENDING, ROADS_SUCCESS, ROADS_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ROADS_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case ROADS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case ROADS_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
